<template>
  <div>
    <vue2-date-picker
      v-model="date"
      :name="name"
      :disabled="disabled"
      :placeholder="computedPlaceholder"
      :input-class="{ 'mx-input':true, 'border-danger': invalid === false }"
      :danger="invalid"
      class="w-100"
      :type="type"
      :format="format"
      :clearable="clearable"
      :multiple="multiple"
      :range="range"
      :disabled-date="disabledDate"
    />
  </div>
</template>

<script>
import Vue2DatePicker from 'vue2-datepicker';
import { format } from 'date-fns';

export default {
  name: 'date-picker',
  emits: [
    'input',
    'formatted-input'
  ],
  data() {
    return {
      date: null,
    };
  },
  watch: {
    date(newVal) {
      console.log('Internal date changed:', newVal);
      const normalized = this.normalizeValue(newVal);
      this.$emit('input', normalized);
      const formated = this.getFormattedDate(normalized);
      this.$emit('formatted-input', formated);
    },
    value: {
      immediate: true,
      handler(newVal) {
        console.log('Value prop changed:', newVal);
        const normalized = this.normalizeValue(newVal);
        if (!this.deepEqualDates(normalized, this.date)) {
          this.date = normalized;
        }
      }
    }
  },
  components: {
    Vue2DatePicker,
  },
  computed: {
    computedPlaceholder() {
      if (this.placeholder) return this.placeholder;
      return this.multiple ? 'Seleccione una o más fechas' : 'Seleccione una fecha';
    },
  },
  methods: {
    getFormattedDate(inputDate) {
      if (!inputDate) return null;
      if (this.multiple || this.range) {
        return inputDate
          .map((d) => (d ? format(d, this.format) : null))
          .filter(Boolean);
      }
      return format(inputDate, this.format);
    },
    disabledDate(date) {
      if (this.disablePastDates) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return date < today;
      }
      return false;
    },
    normalizeValue(val) {
      if (this.multiple || this.range) {
        if (!Array.isArray(val)) return [];
        return val.map(this.toDate).filter(Boolean);
      }
      return this.toDate(val);
    },
    toDate(val) {
      if (!val) return null;
      if (val instanceof Date) return val;
      if (typeof val === 'string') {
        // Preserve time when it is present (e.g. YYYY-MM-DD HH:mm or with "T")
        const dateTimeMatch = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?/.exec(val);
        if (dateTimeMatch) {
          const [, year, month, day, hour, minute, second = '0'] = dateTimeMatch;
          return new Date(
            Number(year),
            Number(month) - 1,
            Number(day),
            Number(hour),
            Number(minute),
            Number(second)
          );
        }
        // YYYY-MM-DD
        const ymdMatch = /^(\d{4})-(\d{2})-(\d{2})/.exec(val);
        if (ymdMatch) {
          const [, year, month, day] = ymdMatch;
          return new Date(Number(year), Number(month) - 1, Number(day));
        }
        // DD-MM-YYYY
        const dmyMatch = /^(\d{2})-(\d{2})-(\d{4})/.exec(val);
        if (dmyMatch) {
          const [, day, month, year] = dmyMatch;
          return new Date(Number(year), Number(month) - 1, Number(day));
        }
      }
      const parsed = new Date(val);
      return Number.isNaN(parsed.getTime()) ? null : parsed;
    },
    deepEqualDates(a, b) {
      if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) return false;
        for (let i = 0; i < a.length; i++) {
          if (!this.deepEqualDates(a[i], b[i])) return false;
        }
        return true;
      }
      if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime();
      }
      return a === b;
    }
  },
  props: {
    name: { type: String, required: true },
    invalid: { type: Boolean, default: null },
    disabled: { type: Boolean, default: false },
    placeholder: { type: String, default: null },
    value: { type: [String, Array, Date], default: null },

    format: { type: String, default: 'DD-MM-YYYY' },
    multiple: { type: Boolean, default: false },
    clearable: { type: Boolean, default: true },
    range: { type: Boolean, default: false },
    type: { type: String, default: 'date' },
    disablePastDates: { type: Boolean, default: false }
  },
  mounted() {
    this.date = this.normalizeValue(this.value);
  }
};
</script>

<style>
.mx-input-wrapper:has(> .border-danger) .mx-icon-calendar {
  color: var(--danger);
}
.mx-input {
  box-shadow: none;
}
</style>
